/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
// icons
import SearchIcon from '@material-ui/icons/Search';
// components

import { compose } from 'redux';
import moment from 'moment';
import { actionProps, selectState } from 'utils/reduxActions';
import { connect } from 'react-redux';
import connectSaga from 'utils/saga';
import produce from 'immer';
import { withRouter } from 'react-router-dom';

import { clone, falsy } from 'utils/functions';
import { receiptsActions } from 'screens/Receipts/reducer';
import { Chip } from '@material-ui/core';
import getQueryParams from 'utils/services/getQueryParams';
import { MultipleSelectorFreeSolo } from 'commons/components/MultipleSelectorFreeSolo';
import saga from '../../saga';
import exportExcel from '../../../../utils/services/exportExcel';
import TableActionMenu from '../../../../commons/components/TableActionMenu';
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';
import DatePicker from '../../../../commons/components/DatePicker';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';
import { shouldUseCallOffInAutomationModals } from 'utils/tenantFeatures';

const style = {
  chipWrapper: {
    maxWidth: '100%',
    maxHeight: '65px',
    overflowY: 'auto',
    overflowX: 'hidden',
    marginBottom: '10px',
  },
};

function Filters(props) {
  const {
    actions,
    classes,
    objects,
    pagination,
    defaultFilters,
    defaultPagination,
    history,
    socketId,
  } = props;
  const { t } = useTranslation();
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: props.role?.name,
  });
  const { canExport } = accessPolicy.receipts;

  const [filter, setFilter] = useState({ ...defaultFilters });
  //defined permissions 
  const canUseAlphanumeric = props.permissions?.includes('alphanumeric_lot_number');

  const canUseAlphanumericShippingGuide = props.permissions?.includes('alphanumeric_shipping_guide');
  const hasAutomation = props.permissions?.includes('AUTOMATION_SUITE');
  const shouldFilterByCallOff = hasAutomation && shouldUseCallOffInAutomationModals();
  const referenceFilterKey = shouldFilterByCallOff ? 'callOff' : 'lotNumber';
  const referenceFilterLabel = shouldFilterByCallOff
    ? t('receipts.filters.callOffNumbers')
    : t('receipts.filters.lotNumbers');
  const defaultReferenceValues = useMemo(() => {
    const params = getQueryParams();
    const value = shouldFilterByCallOff ? params.callOff : params.lotNumber;
    return value ? value.split(',') : [];
  }, [shouldFilterByCallOff]);

  //TODO No se comprueba que funcione correctamente las 3 funcionen siguientes
  const onFilterChange = (event, date) => {
    let input;
    let value;
    if (event.autocomplete) {
      input = event.input;
      value = event.value;
    } else {
      event.persist();
      input = falsy(event.target.type) ? event.currentTarget.id : event.target.id;
      value = event.target.type === 'date' ? date : event.target.value;
    }

    setFilter(
      produce((draft) => {
        draft[input] = value;
      }),
    );
  };

  const onLotNumberChange = (event, lots) => {
    setFilter(
      produce((draft) => {
        draft[referenceFilterKey] = lots;
        draft[referenceFilterKey === 'callOff' ? 'lotNumber' : 'callOff'] = '';
      }),
    );
  };

  useEffect(() => {
    onLotNumberChange(null, defaultReferenceValues);
  }, [defaultReferenceValues]);

  const clearFilters = () => {
    setFilter({ ...defaultFilters });
    actions.paginationControls(defaultFilters, { ...defaultPagination });
  };

  const submitFilter = () => {
    actions.changeFilters(filter);
    actions.getStateFromApi(filter, { ...pagination, page: 0 });
  };

  function onCheckboxChange(date) {
    setFilter(
      produce((draft) => {
        draft.harvestDate = date;
      }),
    );
  }

  const suppliersOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.suppliers).sort((a, b) =>
        a.entity().name.toLowerCase() > b.entity().name.toLowerCase() ? 1 : -1,
      ),
    ],
    [objects.suppliers],
  );

  const clientsOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.clients)
        .filter((client) => client.isInternalClient)
        .sort((a, b) => a.entity().name.toLowerCase() - b.entity().name.toLowerCase()),
    ],
    [objects.clients],
  );

  let productsOptions = useMemo(
    () => ['', ...Object.values(objects?.products).sort((a, b) => a.name - b.name)],
    [objects.products],
  );

  let varietiesOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.varieties || {})
        .filter(v => v && v.name)
        .sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        }),
    ],
    [objects.varieties],
  );

  const fruitsOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.fruits).sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      ),
    ],
    [objects.fruits],
  );

  varietiesOptions = filter.fruitId
    ? varietiesOptions.filter((variety) => variety.fruitId === filter.fruitId)
    : varietiesOptions;

  productsOptions = filter.varietyId
    ? productsOptions.filter((product) => product.varietyId === filter.varietyId)
    : filter.fruitId
      ? productsOptions.filter((product) =>
        varietiesOptions.find((variety) => product.varietyId === variety.id),
      )
      : productsOptions;

  return (
    <Grid item container spacing={3}>
      <Grid item xs={12}>
        <Card className={classes.root}>
          <CardHeader title={t('receipts.filters.title')} />
          <CardContent>
            <Grid container spacing={3} className={classes.container} justifyContent="flex-end">
              <Grid item container spacing={3}>
                <Grid item sm={4} xs={12}>
                  <DatePicker
                    inputId="fromDate"
                    label={t('receipts.filters.from')}
                    fullWidth
                    value={filter.fromDate}
                    onChange={onFilterChange}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <DatePicker
                    inputId="toDate"
                    label={t('receipts.filters.to')}
                    fullWidth
                    value={filter.toDate}
                    onChange={onFilterChange}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <MultipleSelectorFreeSolo
                    id={referenceFilterKey}
                    label={referenceFilterLabel}
                    placeholder={referenceFilterLabel}
                    value={filter[referenceFilterKey]}
                    defaultValue={defaultReferenceValues}
                    onChange={onLotNumberChange}
                    type={canUseAlphanumeric ? 'text' : 'number'}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="paddock-label">{t('receipts.headers.paddock')}</InputLabel>
                    <Select
                      labelId="paddock-label"
                      fullWidth
                      value={filter.paddockId}
                      onChange={onFilterChange}>
                      <MenuItem id="paddockId" value="">
                        {t('receipts.filters.all')}
                      </MenuItem>
                      {Object.values(objects.paddocks)
                        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                        .map((paddock) => (
                          <MenuItem
                            key={`paddock-option-${paddock.id}`}
                            id="paddockId"
                            value={paddock.id}>
                            {paddock.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    id="dispatchOrderNumber"
                    label={t('receipts.filters.dispatchGuide')}
                    value={filter.dispatchOrderNumber}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (!canUseAlphanumericShippingGuide && value && !/^\d+$/.test(value)) {
                        return;
                      }
                      onFilterChange(e);
                    }}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Autocomplete
                    value={
                      filter.supplierId && suppliersOptions.find((s) => s.id === filter.supplierId)
                    }
                    id="autocomplete-suppliers-filters-receipts"
                    options={suppliersOptions}
                    getOptionLabel={(supplier) => supplier && supplier.entity().name}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.headers.supplier')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      const e = {
                        autocomplete: true,
                        input: 'supplierId',
                        value: newValue ? newValue.id : '',
                      };
                      onFilterChange(e);
                    }}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Autocomplete
                    value={filter.clientId && clientsOptions.find((c) => c.id === filter.clientId)}
                    id="autocomplete-clients-filters-receipts"
                    options={clientsOptions}
                    getOptionLabel={(client) => client && client.entity().name}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.headers.internalClient')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      const e = {
                        autocomplete: true,
                        input: 'clientId',
                        value: newValue ? newValue.id : '',
                      };
                      onFilterChange(e);
                    }}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    id="harvester"
                    label={t('receipts.headers.harvester')}
                    value={filter.harvester}
                    onChange={onFilterChange}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <DatePicker
                    disableBox
                    onCheckboxChange={onCheckboxChange}
                    inputId="harvestDate"
                    label={t('receipts.filters.harvestDate')}
                    fullWidth
                    value={filter.harvestDate}
                    onChange={onFilterChange}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Autocomplete
                    value={filter.fruitId && fruitsOptions.find((f) => f.id === filter.fruitId)}
                    id="autocomplete-suppliers-filters-receipts"
                    options={fruitsOptions}
                    getOptionLabel={(fruit) => fruit && fruit.name}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.filters.species')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      const e = {
                        autocomplete: true,
                        input: 'fruitId',
                        value: newValue ? newValue.id : '',
                      };
                      onFilterChange(e);
                    }}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Autocomplete
                    value={
                      filter.varietyId && varietiesOptions.find((v) => v.id === filter.varietyId)
                    }
                    id="autocomplete-suppliers-filters-receipts"
                    options={varietiesOptions}
                    getOptionLabel={(variety) => variety && variety.name}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.filters.variety')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      const e = {
                        autocomplete: true,
                        input: 'varietyId',
                        value: newValue ? newValue.id : '',
                      };
                      onFilterChange(e);
                    }}
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Autocomplete
                    value={
                      filter.productId && productsOptions.find((p) => p.id === filter.productId)
                    }
                    id="autocomplete-suppliers-filters-receipts"
                    options={productsOptions}
                    getOptionLabel={(product) => {
                      if (!product) return '';
                      const name = product.name?.toLowerCase() || '';
                      const code = product.code ? ` (${product.code})` : '';
                      return `${name}${code}`;
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.headers.product')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      const e = {
                        autocomplete: true,
                        input: 'productId',
                        value: newValue ? newValue.id : '',
                      };
                      onFilterChange(e);
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={3} justifyContent="flex-end">
                <Grid item xs={12} sm={4} md={3}>
                  <ButtonWithLoader
                    // @ts-ignore
                    fullWidth
                    onClick={clearFilters}
                    autoFocus
                    buttonId="filter-receipts"
                    className={classes.filterButton}
                    size="small">
                    {t('receipts.filters.clear')}
                  </ButtonWithLoader>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <ButtonWithLoader
                    // @ts-ignore
                    fullWidth
                    onClick={submitFilter}
                    autoFocus
                    buttonId="filter-receipts"
                    className={classes.filterButton}
                    size="small"
                    startIcon={<SearchIcon />}>
                    {t('receipts.filters.search')}
                  </ButtonWithLoader>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {canExport && (
        <Grid item container spacing={3}>
          <Grid item xs={12} sm={4} md={3}>
            <TableActionMenu
              menuItems={[
                {
                  label: t('receipts.filters.export'),
                  listItems: [
                    {
                      label: t('receipts.filters.excelFile'),
                      onClick: exportExcel,
                      params: [{ ...filter, hasAutomation }, 'receipts/export', 'Recepciones', socketId],
                    },
                  ],
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

const withSaga = connectSaga({ key: 'sagaReceipts', saga });

const withConnect = connect(
  selectState('receipts.pagination', 'app.objects', 'app.socketId', 'app.permissions', 'app.role'),
  actionProps(clone(clone.OBJECT, receiptsActions)),
);

export default compose(withRouter, withConnect)(withSaga(Filters));
